module.exports = "/packs/media/images/icons/cashenvelope-61107d4fdb481fbb6d69950b191c7a7d.png";